import { localHref } from "./links";

// Headings that other pages deep-link to keep stable, index-free anchors.
const stableAnchors = {
  "Privacy Policy": "privacy-policy",
  "Technology Solution Path": "technology-solution-path",
};

/** Anchor id for a content heading; the block index keeps repeats unique. */
export function headingId(text, index) {
  if (stableAnchors[text]) return stableAnchors[text];
  const slug = text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return `${slug || "section"}-${index}`;
}

/** Point links inside sanitized captured HTML at their local equivalents. */
export function localizeHtml(html = "") {
  return html.replace(
    /href="([^"]+)"/g,
    (_, url) => `href="${localHref(url).replace(/"/g, "&quot;")}"`,
  );
}

/** Body blocks up to (not including) the first block whose text matches. */
export function blocksBefore(blocks, pattern) {
  const index = blocks.findIndex((block) => pattern.test(block.text || ""));
  return index >= 0 ? blocks.slice(0, index) : blocks;
}

/** Team cards are titled "Name | Role". */
export function parseTeamTitle(title) {
  const [name, role] = title.split("|");
  return { name: name.trim(), role: role?.trim() };
}

// Named like a logo but actually a photo (the LoadTraxx app on a phone).
const notLogos = /Loadtraxx-logo-1/i;

/** Logos and small thumbnails, which render at logo size rather than as photos. */
export const isSupportingMark = (src) =>
  /logo|150x150|300x300|image00220230919/i.test(src) && !notLogos.test(src);

/** The same picture under different WordPress size names counts as one image. */
export const imageKey = (src) =>
  src
    .slice(src.lastIndexOf("/") + 1)
    .replace(/-\d+x\d+(?=\.\w+$)/, "")
    .toLowerCase();
